<div class="nav-group" *ngFor="let nav of navigationItems">
    <!-- Render parent nav -->
    <div class="title">
      <span>{{ nav.label }}</span>
      <txp-button data-qa-label="ActionButton"
                  class="action-button"
                  *ngIf="nav.button"
                  [style]="buttonStyle.PRIMARY"
                  [size]="buttonSize.EXTRA_SMALL"
                  [attr.title]="nav.button.text"
                  (click)="nav.button.action()">
        {{ nav.button.text }}
      </txp-button>
    </div>

    <!-- Render Children -->
    <ng-template ngFor let-child [ngForOf]="nav.children" let-i="index">
        <div class="item"
                *ngIf="isHidden(child.permission)"
                [ngClass]="{'selected': child.selected }"
                (click)="handleChildClick(child, nav)">
            <div class="name">
                {{ child.label }}
            </div>
            <div class="status">
                <i class="tce-icon-circle-check" *ngIf="(child.indicator | async) === true"></i>
                <i class="tce-icon-circle-cross" *ngIf="(child.indicator | async) === false"></i>
            </div>
        </div>
    </ng-template>
</div>
